import axios from 'axios';
import sdata from './_/sdata'
import sname from './_/sname'

export default function (context, val) {
    let name = val;
    let setting = context.state[name];
    if (setting && setting.load) return;
    if (setting.data) return;
    setting.load = true;
    axios({
        method: 'post',
        url: '/tourclient/legend/getLegend',
        data: 'request=' + JSON.stringify({ScreenName: sname(name)}),
        requestId: '/tourclient/legend/getLegend/' + name
    }).then(({data}) => {
        context.dispatch(name + '/set', sdata(data));
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}